import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
import DataTableWithOutSearch from '../datatables/DataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from 'moment';
import PreloaderTwo from '../preloader/PreloaderTwo';

import { withRouter } from "react-router-dom";

const FETCH_PROCTORING_EXAMS = gql`
query($institution_id: Int!, $exam_id: Int) {
  getProctoringExams(institution_id: $institution_id, exam_id: $exam_id){
    mobile
    exam_name
    proctoring_type_id
    exam_paper_id
    inserted_at
    estatus
  }
}
`;

class ProctoringStudentDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableHeaderData: {
                Title: 'Proctoring Student Details'
            }
        }
    }

    articlecolumns = [
        {
            dataField: "examName",
            text: "Exam Name",
            sort: true
        },
        {
            dataField: "dateTime",
            text: "Time & Date",
            sort: true
        },
        {
            dataField: "mobile",
            text: "Mobile",
            sort: true
        },
        {
            dataField: "proctoringType",
            text: "Proctoring Type",
            sort: true
        },
        {
            dataField: "status",
            text: "Status",
            sort: true
        }
    ];

    defaultSorted = [
        {
            dataField: "dateTime",
            order: "desc"
        }
    ];

    tableUserData(proctoringExams) {
        if (!proctoringExams) return [];

        return proctoringExams.map((exam, index) => ({
            id: index + 1,
            examName: exam.exam_name,
            dateTime: exam.inserted_at ? moment(exam.inserted_at).format("YYYY-MM-DD | hh:mm A") : "N/A",
            mobile: exam.mobile,
            proctoringType: exam.proctoring_type_id,
            status: exam.estatus
        }));
    }

    render() {
        const { getProctoringExams } = this.props;

        if (getProctoringExams && getProctoringExams.loading) {
            return <PreloaderTwo />;
        }

        if (getProctoringExams && getProctoringExams.error) {
            return (
                <div className="alert alert-danger">
                    Error loading proctoring exams: {getProctoringExams.error.message}
                </div>
            );
        }

        const examsData = getProctoringExams ? getProctoringExams.getProctoringExams : [];

        return (
            <React.Fragment>
                <div className="user-creation">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-3 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title font-weight-normal h5 mb-0">Proctoring Students</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <DataTableWithOutSearch
                                parentData={this.tableUserData(examsData)}
                                particlecolumns={this.articlecolumns}
                                tableHeading={this.state.tableHeaderData}
                                defaultSorted={this.defaultSorted}
                                name={this.state.tableHeaderData.Title}
                            />
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default compose(
    withRouter,
    graphql(FETCH_PROCTORING_EXAMS, {
        options: props => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_id: props.location && props.location.state ? parseInt(props.location.state.exam_id) : null
            },
            fetchPolicy: 'network-only'
        }),
        name: "getProctoringExams"
    })
)(ProctoringStudentDetails);
